import React, { useState } from "react";
import "./ClientForm.css";
import { Line, MaterialType, Province } from "../types/canvasTypes";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { ClientDetails } from "../pages/QuotationDetails";
import { useCurrentUser } from "../context/UserContext";
import { useOptionContext } from "../context/OptionContext";

const initialFormState: ClientDetails = {
  name: "",
  email: "",
  phone: "",
  address: "",
  note: "",
  chalkLine: false,
};

type Props = {
  lines: Line[];
  material: MaterialType;
  selectedLength: String;
  scale: number;
  includeAttachement: boolean;
};

const ClientForm = (props: Props) => {
  const [formData, setFormData] = useState<ClientDetails>(initialFormState);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add state variable for submitting status
  const { chalkLine, province, gapSize } = useOptionContext();
  const navigate = useNavigate();

  const { currentUser } = useCurrentUser();
  const canAccess = currentUser || province === Province.Quebec;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!canAccess || isSubmitting) return; // Check if already submitting

    setIsSubmitting(true); // Set submitting status to true

    try {
      const docRef = await addDoc(collection(db, "quotations"), {
        ...formData,
        lines: JSON.stringify(props.lines),
        material: props.material,
        selectedLength: props.selectedLength,
        scale: props.scale,
        includeAttachement: props.includeAttachement,
        date: new Date(),
        createdBy: currentUser?.email || "guest",
        chalkLine,
        province,
        gapSize,
      });
      navigate(`/quotations/${docRef.id}`);
    } catch (e) {}

    setIsSubmitting(false); // Set submitting status back to false
  };

  const checkDisabled = formData.email === "" || isSubmitting; // Disable button if already submitting

  return (
    <form className="client-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label>{province === Province.Ontario ? "name" : "nom"}</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label>email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-group">
        <label>
          {province === Province.Ontario ? "Phone Number" : "telephone"}
        </label>
        <input
          type="text"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />
      </div>
      <div className="form-group">
        <label>{province === Province.Ontario ? "address" : "adress"}</label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
        />
      </div>
      {province === Province.Ontario && (
        <div className="form-group">
          <label>{province === Province.Ontario ? "Notes" : "billet"}</label>
          <input
            type="text"
            name="note"
            value={formData.note}
            onChange={handleChange}
          />
        </div>
      )}
      <button
        type="submit"
        disabled={isSubmitting || checkDisabled || !canAccess}
        className="edit-button"
      >
        {canAccess
          ? province === Province.Ontario
            ? "Save"
            : "Sauvegarder"
          : "login"}
      </button>
    </form>
  );
};

export default ClientForm;
